import HttpClient from "../HttpClient";
import Op from "../interfaces/SequalizeFilters/SequalizeTypes";
import moment from "moment";

export type HouseServiceStatus =
  | "PENDING"
  | "COOK_ALLOCATED"
  | "COOK_CONFIRMED"
  | "ONGOING"
  | "CANCELLED"
  | "FULFILLED"
  | "RESCHEDULED";

export type HouseLocationItem = Record<string, any>;

export interface HouseLocationFilters {
  status?: HouseServiceStatus;
  paymentStatus?: string;
  date?: string;
  time?: string;
  city?: string;
}

export default class HouseLocationService {
  async getHouseLocations(options: HouseLocationFilters = {}): Promise<HouseLocationItem[]> {
    const date = options.date || moment().format("YYYY-MM-DD");

    const filters: Record<string, any> = {};

    const status = options.status || "PENDING";
    filters["status"] = { [Op.eq.toString()]: status };

    if (options.paymentStatus && options.paymentStatus !== "ALL") {
      filters["paymentStatus"] = { [Op.eq.toString()]: options.paymentStatus };
    }

    if (options.time) {
      filters["time"] = { [Op.eq.toString()]: options.time };
    }

    if (options.city) {
      filters["cityName"] = { [Op.eq.toString()]: options.city };
    }

    const response = await HttpClient.get<HouseLocationItem[]>(
      "/centaurus/one-meal-service/house-locations",
      { params: { date, filters } }
    );
    return response.data || [];
  }
}
